import { Component, OnInit, Injector, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { GlobalsService } from '../../shared/shared';
import { User } from "../../schemas/schemas";

@Component({
    selector: 'nepraunik-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {
    public user: User;

    constructor(public router: Router, private globalsService: GlobalsService, private authService: AuthService) {
        this.user = authService.getUser();
    }

    public logout() {
        if (this.authService.logout())
            this.router.navigate(['/login']);
        else
            console.log("Error on logout");
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// ./src/app/_authentication/logout/logout.component.ts